import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ContentfulLinkAnchor } from './styles';
import getUrlState from './utils/getUrlState';
const ContentfulLink = (props) => {
    const { url, to, children, style, className, onClick, onMouseEnter, onMouseLeave, } = props;
    const { state, formattedUrl } = useMemo(() => getUrlState(url !== null && url !== void 0 ? url : to), [url, to]);
    const { openInNewTab = ['external', 'hubspot', 'contact'].includes(state) } = props;
    if (formattedUrl === '') {
        return null;
    }
    switch (state) {
        case 'external':
            return (_jsx(ContentfulLinkAnchor, { href: formattedUrl, target: openInNewTab ? '_blank' : undefined, rel: `nofollow noopener noreferrer`, style: style, className: className, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: children }));
        case 'hubspot':
        case 'app':
        case 'contact':
            return (_jsx(ContentfulLinkAnchor, { href: formattedUrl, target: openInNewTab ? '_blank' : undefined, rel: `noopener`, style: style, className: className, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: children }));
        case 'clickable':
            return (_jsx("div", { style: style, className: className, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: children }));
        default:
            return (_jsx(Link, { to: formattedUrl, style: style, target: openInNewTab ? '_blank' : undefined, className: className, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: children }));
    }
};
export default ContentfulLink;
